import {
  FETCH_CURRENT_USER,
  SET_CURRENT_USER_LOADING,
  FETCH_PROFILE_DATA,
  UPDATE_PROFILE_DATA,
  FETCH_TRAVELER_PREFERENCES,
  FETCH_TRAVELER_DETAILS,
  FETCH_TRAVELER_NOTES,
  FETCH_TRAVELER_MESSAGES,
  FETCH_TRAVELER_MESSAGES_REQUEST,
  FETCH_TRAVELER_MESSAGES_FAILURE,
  CREATE_TRAVELER_MESSAGE,
  CREATE_TRAVELER_MESSAGE_LOADING,
  CHECK_TRAVELER_MESSAGE,
  FETCH_ASSIGNED_ADMINS,
  UPDATE_ASSIGNED_ADMINS,
  FETCH_TRAVELER_HEADER,
  FETCH_TRAVELER_INSIGHT,
  SELECT_TRAVELER_PROFILE_TAB,
  SELECT_MESSAGE_TAB,
  CREATE_TRAVELER_NOTE,
  RESET_PROFILE_CODE,
  FETCH_NEW_MESSAGES,
  FETCH_NEW_MESSAGES_TRAVELER,
  RESET_MESSAGE_CREATE_CODE,
  ADD_NEW_FORM,
  FETCH_GENDER_IDENTITIES,
  MANUAL_SYNC_TRAVELER,
  CLEAR_MANUAL_SYNC_TRAVELER,
  DELETE_TRAVELER_REQUEST,
  DELETE_TRAVELER_SUCCESS,
  DELETE_TRAVELER_CLEAR,
  DELETE_TRAVELER_FAILURE,
  CHECK_USER_FAVORITE_DISCLAIMER,
  MARK_ALL_READ_MESSAGE_SUCCESS,
  MARK_ALL_READ_MESSAGE_REQUEST,
  MARK_ALL_READ_MESSAGE_FAILURE,
  TOGGLE_PROGRAM_FAVORITE,
  FETCH_TERM_POLICY_REQUEST,
  FETCH_TERM_POLICY_SUCCESS,
  FETCH_TERM_POLICY_FAILURE,
  ACCEPT_TERM_REQUEST,
  ACCEPT_TERM_SUCCESS,
  ACCEPT_TERM_FAILURE,
  ASSIGN_TRAVELER_TAGS_REQUEST,
  ASSIGN_TRAVELER_TAGS_SUCCESS,
  ASSIGN_TRAVELER_TAGS_FAILURE,
  ASSIGN_TRAVELER_TAGS_CLEAR,
  FETCH_TRAVELER_TODOLIST,
  UPDATE_PROFILE_EMAIL_SUCCESS,
} from '../actions/types';
import _cloneDeep from 'lodash/cloneDeep';
import _map from 'lodash/map';

// The get_messages API can return the same admin more than once in
// assigned_admins (e.g. a proxy user listed twice), which renders duplicate
// recipients. De-duplicate by admin_id (falling back to email) before storing.
const dedupeByAdminId = (admins = []) => {
  if (!Array.isArray(admins)) return admins;
  const seen = new Set();
  return admins.filter(admin => {
    const key = admin?.admin_id ?? admin?.rest?.id ?? admin?.rest?.email;
    if (key == null) return true;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

const initialState = {
  currentUserLoading: false,
  profileLoading: true,
  preferencesLoading: true,
  detailsLoading: true,
  notesLoading: true,
  headerLoading: true,
  messagesLoading: true,
  userLoading: true,
  newMessagesLoading: true,
  currentUser: {},
  avatar: {},
  permissions: {},
  profile: [],
  header: [],
  travelerInsight: [],
  preferences: [],
  applications: [],
  favorites: [],
  forms: [],
  notes: [],
  messages: [],
  newMessages: [],
  admins: [],
  assignedAdmins: [],
  messageRead: null,
  events: [],
  activeTab: 'messages',
  activeMessageTab: 'messages',
  updateProfileStatus: null,
  messageCreate: null,
  noteCreate: null,
  errorUpdateStatus: '',
  errorUpdateFormStatus: '',
  freemium: false,
  clientAccountState: '',
  lead: false,
  logout_url: '',
  clientFeatureList: {},
  customAliases: {
    alias_program: 'Program',
    alias_programs: 'Programs',
    alias_traveler: 'Traveler',
    alias_travelers: 'Travelers',
    alias_traveling: 'Traveling',
  },
  customBranding: {
    themes: {
      theme_color_accent: '#DD602A',
      theme_color_dark: '#00277C',
      theme_color_light: '#65A5E0',
    },
    logo: {
      theme_logo: '/uploads/client_account_info/logo/62/client_logo.jpg',
    },
  },
  safecheck: '',
  safecheckStatus: '',
  show_intake: null,
  show_program_match: null,
  show_traveler_welcome_screen: null,
  allow_traveler_defer_application: true,
  intake_complete: null,
  program_match_complete: null,
  manualSync: null,
  deleteTraveler: {
    data: null,
    loading: true,
    error: null,
  },
  role: '',
  program_favorite_disclaimer_accepted: false,
  messageLoading: false,
  messageError: '',
  createMessageLoading: false,
  favoriteProgram: {
    flag: false,
    programId: '',
  },
  termsOfUse: {
    id: '',
    type: '',
    term_of_services: '',
    client_account_id: '',
    privacy_policy: '',
    loading: false,
    error: '',
  },
  acceptTerms: {
    loading: false,
    error: '',
  },
  assignTravelerTags: {
    loading: false,
    error: '',
    message: null,
  },
  myTodoList: {
    data: null,
    error: false,
  },
  authorized_program_unverified_link_enabled: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_USER_LOADING:
      return {
        ...state,
        currentUserLoading: action.payload,
      };

    case FETCH_CURRENT_USER: {
      const payload = action.payload || {};
      const setUser = payload.user || {};
      setUser['client_user_role?'] = setUser.admin_sign_in;
      setUser['is_traveler?'] = !setUser.admin_sign_in;
      const userRole = setUser.admin_sign_in ? 'admin' : 'traveler';
      const featureList = payload.client_feature_list || {};

      return {
        ...state,
        currentUser: setUser,
        avatar: payload.avatar,
        permissions: payload.permissions,
        customBranding: payload.branding_theme,
        profileInfo: payload.profile_info,
        customAliases: payload.use_custom_aliases ? payload.custom_aliases : state.customAliases,
        safeCheckCustomMessage: payload.client_account_safe_check_custom_text,
        freemium: payload.freemium,
        clientAccountState: payload.client_account_state,
        clientAccountName: payload.client_account_name,
        lead: payload.lead,
        orgTimezone: payload.org_timezone,
        other_admin_limit: payload.other_admin_limit,
        logout_url: payload.logout_url || '',
        clientFeatureList: featureList,
        userLoading: false,
        safecheck: payload.safe_check_phone_number,
        safecheckStatus: payload.safe_check_enrollment_status,
        show_intake: payload.show_intake,
        show_program_match: payload.show_program_match,
        show_traveler_welcome_screen: payload.show_traveler_welcome_screen,
        super_user_limit: payload.super_user_limit,
        allow_traveler_defer_application: payload.allow_traveler_deferral,
        admin_access: payload.admin_access,
        admin_sign_in: payload.admin_sign_in,
        intake_complete: payload.intake_complete,
        program_match_complete: payload.program_match_complete,
        role: payload.role,
        standard_report_notification_read: payload.standard_report_notification_read,
        program_favorite_disclaimer_accepted: payload.program_favorite_disclaimer_accepted,
        proxy_management: featureList.proxy_management,
        is_proxy_user: setUser.is_proxy_user,
        is_authorized_traveler: setUser.is_authorized_traveler,
        proxy_user_id: setUser.proxy_user_id,
        user_role: userRole,
        proxy_user: payload.proxy_user,
        customPlanInstruction: payload.display_custom_instruction || false,
        customPlanInstructionText: payload.custom_instruction || "",
        authorized_program_unverified_link_enabled: payload.authorized_program_unverified_link_enabled,
      };
    }
    case CHECK_USER_FAVORITE_DISCLAIMER:
      return {
        ...state,
        program_favorite_disclaimer_accepted: action.payload,
      };
    case FETCH_PROFILE_DATA:
      return {
        ...state,
        profile: action.payload,
        profileLoading: false,
      };
    case FETCH_TRAVELER_DETAILS:
      return {
        ...state,
        applications: action.payload.applications,
        favorites: action.payload.favorite_programs,
        forms: action.payload.forms,
        events: action.payload.events,
        detailsLoading: false,
      };
    case UPDATE_PROFILE_DATA:
      return {
        ...state,
        updateProfileStatus: action.success,
        profile: action.payload,
      };
    case UPDATE_PROFILE_EMAIL_SUCCESS:
      return {
        ...state,
      };
    case FETCH_TRAVELER_HEADER:
      return {
        ...state,
        header: action.payload,
        headerLoading: false,
      };
    case FETCH_TRAVELER_INSIGHT:
      return {
        ...state,
        travelerInsight: action.payload,
        headerLoading: false,
      };
    case FETCH_TRAVELER_PREFERENCES:
      return {
        ...state,
        preferences: action.payload,
        preferencesLoading: false,
      };
    case FETCH_TRAVELER_NOTES:
      return {
        ...state,
        notes: action.payload,
        noteCreate: null,
        notesLoading: false,
      };
    case CREATE_TRAVELER_NOTE:
      return {
        ...state,
        note: action.payload,
        noteCreate: action.payload.status,
        notes: [action.payload.data, ...state.notes.data],
        notesLoading: false,
      };

    case FETCH_TRAVELER_MESSAGES_REQUEST:
      return {
        ...state,
        messageLoading: true,
      };

    case FETCH_TRAVELER_MESSAGES:
      return {
        ...state,
        messages: action.payload.messages,
        messageCreate: null,
        assignedAdmins: dedupeByAdminId(action.payload.assigned_admins),
        admins: action.payload.available_admins,
        messagesLoading: false,
        currentUserAvatar: action.payload.current_user_avatar,
        messageLoading: false,
      };

    case FETCH_TRAVELER_MESSAGES_FAILURE:
      return {
        ...state,
        messageLoading: false,
        messageError: action.payload,
      };

    case MARK_ALL_READ_MESSAGE_REQUEST:
      return {
        ...state,
        messageLoading: true,
      };

    case MARK_ALL_READ_MESSAGE_SUCCESS:
      return {
        ...state,
        messageLoading: false,
      };

    case MARK_ALL_READ_MESSAGE_FAILURE:
      return {
        ...state,
        messageLoading: false,
        messageError: action.payload,
      };

    case CREATE_TRAVELER_MESSAGE:
      return {
        ...state,
        messageCreate: action.payload.status,
      };

    case CREATE_TRAVELER_MESSAGE_LOADING:
      return {
        ...state,
        createMessageLoading: action.payload,
      };

    case CHECK_TRAVELER_MESSAGE:
      const existingAllMessages = [...state.messages];
      existingAllMessages.filter(msg => {
        if (msg.message_id === action.payload.id) {
          msg.is_read = true;
          return true;
        }
      });
      return {
        ...state,
        messageRead: action.success,
        messagesLoading: false,
        messages: existingAllMessages,
      };
    case UPDATE_ASSIGNED_ADMINS:
      return {
        ...state,
        assignedAdmins: action.payload,
        adminsLoading: false,
      };
    case SELECT_TRAVELER_PROFILE_TAB:
      return {
        ...state,
        activeTab: action.tab,
        updateProfileStatus: null,
      };
    case SELECT_MESSAGE_TAB:
      return {
        ...state,
        activeMessageTab: action.tab,
      };
    case RESET_PROFILE_CODE:
      return {
        ...state,
        updateProfileStatus: false,
      };
    case RESET_MESSAGE_CREATE_CODE:
      return {
        ...state,
        messageCreate: null,
      };
    case FETCH_NEW_MESSAGES:
      return {
        ...state,
        newMessages: action.payload,
        newMessagesLoading: false,
      };
    case FETCH_NEW_MESSAGES_TRAVELER:
      return {
        ...state,
        newMessages: action.payload,
        newMessagesLoading: false,
      };




    case ADD_NEW_FORM:
      let forms = _cloneDeep(state.forms);
      forms.push(action.payload);
      return {
        ...state,
        forms: forms,
      };
    case FETCH_GENDER_IDENTITIES:
      return {
        ...state,
        allGenderIdentities: action.payload.data,
      };
    case MANUAL_SYNC_TRAVELER:
      return {
        ...state,
        manualSync: action.payload,
      };
    case CLEAR_MANUAL_SYNC_TRAVELER:
      return {
        ...state,
        manualSync: null,
      };
    case DELETE_TRAVELER_REQUEST:
      return {
        ...state,
        deleteTraveler: {
          data: null,
          loading: true,
          error: null,
        },
      };
    case DELETE_TRAVELER_SUCCESS:
      return {
        ...state,
        deleteTraveler: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };
    case DELETE_TRAVELER_FAILURE:
      return {
        ...state,
        deleteTraveler: {
          data: null,
          loading: false,
          error: action.payload,
        },
      };
    case DELETE_TRAVELER_CLEAR:
      return {
        ...state,
        deleteTraveler: {
          data: null,
          loading: false,
          error: null,
        },
      };

    case TOGGLE_PROGRAM_FAVORITE:
      return {
        ...state,
        favoriteProgram: {
          flag: action.payload.flag,
          programId: action.payload.programId,
        },
      };

    case FETCH_TERM_POLICY_REQUEST:
      return {
        ...state,
        termsOfUse: {
          ...state.termsOfUse,
          loading: true,
        },
      };

    case FETCH_TERM_POLICY_SUCCESS:
      return {
        ...state,
        termsOfUse: {
          ...state.termsOfUse,
          loading: false,
          id: action.payload.id,
          type: action.payload.type,
          term_of_services: action.payload.term_of_services,
          client_account_id: action.payload.client_account_id,
          privacy_policy: action.payload.privacy_policy,
        },
      };

    case FETCH_TERM_POLICY_FAILURE:
      return {
        ...state,
        termsOfUse: {
          ...state.termsOfUse,
          loading: false,
          error: action.payload,
        },
      };

    case ACCEPT_TERM_REQUEST:
      return {
        ...state,
        acceptTerms: {
          ...state.acceptTerms,
          loading: true,
        },
      };

    case ACCEPT_TERM_SUCCESS:
      return {
        ...state,
        acceptTerms: {
          loading: false,
          error: '',
        },
      };

    case ACCEPT_TERM_FAILURE:
      return {
        ...state,
        acceptTerms: {
          loading: false,
          error: action.payload,
        },
      };


    case ASSIGN_TRAVELER_TAGS_CLEAR:
      return {
        ...state,
        assignTravelerTags: {
          data: null,
          loading: false,
          error: false,
          message: null,
        },
      };
    case ASSIGN_TRAVELER_TAGS_REQUEST:
      return {
        ...state,
        assignTravelerTags: {
          data: null,
          loading: true,
          error: false,
          message: null,
        },
      };
    case ASSIGN_TRAVELER_TAGS_SUCCESS:
      return {
        ...state,
        assignTravelerTags: {
          data: action.payload.data,
          loading: false,
          error: false,
          message: action.message,
        },
      };
    case ASSIGN_TRAVELER_TAGS_FAILURE:
      return {
        ...state,
        assignTravelerTags: {
          data: null,
          loading: false,
          error: true,
          message: action.message,
        },
      };
    case FETCH_TRAVELER_TODOLIST:
      return {
        ...state,
        myTodoList: {
          data: action.payload.data,
          error: action.payload.error,
        },
      };
    default:
      return state;
  }
}
